import React, { Component } from "react";
import { Form, Steps } from "antd";
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import {
  notificationTitle,
  openNotificationType,
} from "swfrontend/MDM/MDMUIConfigs/MDMUIMappings";
import StepsHeader from "./Components/StepsHeader";
import AN13DataProvider from "./AN13DataProvider";
import RegistrationFormView from "../../Registration/RegistrationFormView/RegistrationFormView";
import CustomerCodeRequest from "./Components/CustomerCodeRequest";
import {
  NOTIFICATION,
  MULTIVALUE_FIELD,
  CUSTOMER_GROUP,
  CLIENT_ID,
  title,
  REG_VALIDATE_FIELDS,
  SCROLL_TO_FIELD_FOR_MULTIV,
  DEFAULT_FME_DATA,
  VALIDATE_FIELDS,
} from "./Constants";
import {
  phoneNumberRegex,
  mailRegex,
  telephoneRegex,
  invalidCharacterValidator,
} from "../../Registration/RegistrationFormView/validators";
import { Dynamic_Error, Internal_Server_Error } from "./AN13FormHelper";
import CustomLoader from "../../Registration/RegistrationFormView/Components/CustomLoader";
import {
  DEPENDENT_DROPDOWN_FIELDS,
  DROPDOWN_FIELDS,
  MULTIVALUE_FIELDS,
  NOTIFICATIONS,
  SUBMIT_VALUES,
  CONTACT_PERSON_FIELDS
} from "../../../constants";
import { ErrorLogger } from "../../../../App/Utils/ErrorHandler";
import RegistrationDataProvider from "../../Registration/RegistrationFormView/RegistrationDataProvider";

const { Step } = Steps;

class AN13FormView extends Component {
  formRef = React.createRef();
  DataProvider = new AN13DataProvider();
  RegistrationDataProvider = new RegistrationDataProvider();

  state = {
    currentStep: 0,
    all_data: {},
    isLoading: false,
    message: NOTIFICATION.WAIT,
    is_duplicate_emp_code: false,
    othertype: {},
    salesGroupData: [],
    additional_details: {
      contact_person_details: []
    }
  };

  componentDidMount() {
    if (
      window.location.pathname.includes(
        process.env.REACT_APP_PROJECT_ROUTE + "/RegisterFME"
      )
    ) {
      window.onbeforeunload = function () {
        return "";
      };
    }

    this.get_default_fme_values();
    this.formRef.current.setFieldsValue({
      client_id: CLIENT_ID,
    });
  }

  /**
   * Called on next and submit button click
   * @param {*} values Contains the form fields values
   */
  onFinish = (values) => {
    try {
      values.acc_group = CUSTOMER_GROUP;
      // VALIDATE DUPLICATE EMP CODE
      if (this.state.is_duplicate_emp_code) {
        this.formRef.current.scrollToField(
          VALIDATE_FIELDS.external_number_range
        );
        this.formRef.current.setFields([
          {
            name: VALIDATE_FIELDS.external_number_range,
            errors: [NOTIFICATION.DUPLICATE_EMP_CODE],
          },
        ]);
        return;
      }

      // To Set Multi Value fields in proper format
      Object.keys(MULTIVALUE_FIELDS).map((each_field) => {
        let new_list = [];
        if (values[each_field] !== undefined) {          
          values[each_field].map((each_record) => {
            if (each_record !== undefined) {
              if (each_record.value !== "")
                new_list = [...new_list, each_record.value];
            }
          });
          values[each_field] = new_list;
        }
      });

      // VALIDATE MOBILE AND TELEPHONE ONLY FOR INDIAN
      let isValidMob = true;
      // let isValidTel = true;
      let isValidEmail = true;
      if (values.country === 101) {
        // MOBILE
        isValidMob = this.validateMobTeleEmail(
          values.company_contactno,
          telephoneRegex,
          NOTIFICATIONS.MOB_INVALID
        );
      }

      //VALIDATE EMAIL ADDRESS
      isValidEmail = this.validateMobTeleEmail(
        values.company_email,
        mailRegex,
        NOTIFICATIONS.EMAIL_INVALID
      );

      // return IF MOBILE OR TELEPHONE NUM OR EMAIL IS INVALID IS INVALID
      if (!isValidMob || !isValidEmail) {
        return;
      }

      // EXTERNAL NUMBER RANGE VALIDATION
      if (
        values.external_number_range !== undefined &&
        values.external_number_range !== "" &&
        (values.external_number_range > 29999999 ||
          values.external_number_range < 20000000)
      ) {
        this.formRef.current.scrollToField(
          VALIDATE_FIELDS.external_number_range
        );
        openNotification(
          openNotificationType.error,
          notificationTitle.form,
          NOTIFICATIONS.EXTERNAL_NUM_RANGE
        );
        return;
      }

      // REMOVE NULL VALUES OF CONTACT PERSON DETAILS FIELDS AND UPDATE WITH STATE DATA
      CONTACT_PERSON_FIELDS.map((each_field) => {
        delete values[each_field];
      });

      values.contact_person_details = this.state.additional_details.contact_person_details;
      
      //TO MANAGE SELETED OTHERTYPE FROM CMB
      let { othertype, otherCity } = this.state;
      Object.keys(othertype).map((key) => {
        delete values[key];
        values[`${SUBMIT_VALUES.OTHER}_${key}`] = othertype[key].name;
      });

      if (values.city === 0) {
        delete values.city;
        values[`${SUBMIT_VALUES.OTHER}_${DROPDOWN_FIELDS.city}`] =
          otherCity[0].name;
      }

      // DO NOT PROCEED IF HAVING SPECIAL CHARACTERS
      if (invalidCharacterValidator(values, this.formRef) === false) return;

      this.setState({ isLoading: true, message: NOTIFICATION.LOADING });

      let formData = new FormData();
      formData.append("data", JSON.stringify(values));
      this.DataProvider.registration_customer_api(formData)
        .then((res) => {
          if (res.ok) {
            openNotification(
              openNotificationType.success,
              notificationTitle.form,
              NOTIFICATIONS.SUCCESS_REGISTER
            );
            setTimeout(() => {
              window.onbeforeunload = null;
              window.location.reload();
            }, 1000);
          } else {
            return res.json().then((res) => {
              Object.keys(res).map((k) => {
                let title = k.replace("_", " ").replace("_", " ");
                title = title.charAt(0).toUpperCase() + title.slice(1);

                openNotification(openNotificationType.error, title, res[k]);
              });
            });
          }
        })
        .finally(() =>
          this.setState({
            isLoading: false,
            message: NOTIFICATION.WAIT,
          })
        );
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
      Internal_Server_Error();
    }
  };

  validateCustomerEmail = (customer_email) => {
    let isValid = true;
    if (
      customer_email === undefined ||
      customer_email === null ||
      customer_email.length === 0
    ) {
      isValid = false;
    }

    if (isValid && customer_email[0].value === "") {
      isValid = false;
    }

    if (!isValid) {
      this.setState({ currentStep: 0 });
      this.formRef.current.scrollToField(
        SCROLL_TO_FIELD_FOR_MULTIV.contact_person_designation
      );
      openNotification(
        openNotificationType.error,
        notificationTitle.form,
        NOTIFICATIONS.CUST_EMAIL
      );
    }

    return isValid;
  };

  /**
   * This method is called when some Error occurs in the Form Fields
   * @param {*} values Error Field Values
   */
  onFinishFailed = (values) => {
    this.formRef.current.scrollToField(values.errorFields[0].name);

    // MOVE TO REG FORM IF ERROR FIELD FOUND IN REG FIELDS
    REG_VALIDATE_FIELDS.forEach((each_field) => {
      if (values.errorFields[0].name[0] === each_field) {
        this.setState({ currentStep: 0 });
      }
    });

    //SHOW ERROR NOTIFICATION
    try {
      if (values.errorFields.length > 3) {
        openNotification(
          openNotificationType.error,
          notificationTitle.form,
          NOTIFICATIONS.FORM_VALIDATION
        );
      } else {
        values.errorFields.map((each) => {
          openNotification(
            openNotificationType.error,
            notificationTitle.form,
            each.errors[0]
          );
        });
      }

      return false;
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
      Internal_Server_Error();
    }
  };

  validateMobTeleEmail = (values, regex, msg) => {
    try {
      let isValidMobTeleEmail = true;
      values.map((each, index) => {
        if (!each.match(regex)) {
          openNotification(
            openNotificationType.error,
            notificationTitle.form,
            each + msg
          );

          isValidMobTeleEmail = false;
        }
      });

      if (!isValidMobTeleEmail) {
        this.setState({ currentStep: 0 });
        this.formRef.current.scrollToField(
          SCROLL_TO_FIELD_FOR_MULTIV.fme_name
        );
      }

      return isValidMobTeleEmail;
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
      Internal_Server_Error();
    }
  };

  /**
   * This Method is Called when clear button is pressed
   * To clear form field values
   */
  onResetFields = () => {
    try {
      this.formRef.current.resetFields();
      // GET DEFAULT CODE REQUEST VALUES
      this.get_default_fme_values();
      this.formRef.current.setFieldsValue({
        client_id: CLIENT_ID,
      });
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
      Internal_Server_Error();
    }
  };

  /**
   * This Method is used to set default fme dropdowns
   *
   */
  get_default_fme_values = () => {
    try {
      this.setState({ isLoading: true });
      this.DataProvider.get_default_fme_values("", "AN13")
        .then((res) => {
          if (res.ok) {
            return res.json().then((res) => {
              if (DROPDOWN_FIELDS.sales_office in res) {
                //TO LOAD SALES GROUP DATA
                this.get_dropdown_dependent_default_value(
                  DEPENDENT_DROPDOWN_FIELDS.sales_group.app,
                  DEPENDENT_DROPDOWN_FIELDS.sales_group.model,
                  DEPENDENT_DROPDOWN_FIELDS.sales_group.dependent,
                  res.sales_office,
                  DEPENDENT_DROPDOWN_FIELDS.sales_group.storein,
                  res.source
                );
              }

              // STORE SOURCE TO BE USED IN LATER IN DRODOWN
              this.setState({source: res.source})

              Object.keys(res).forEach((decorator) => {
                this.formRef.current.setFieldsValue({
                  [decorator]: res[decorator],
                });
              });
            });
          } else {
            return res.json().then((res) => {
              Object.keys(res).forEach((k) => {
                Dynamic_Error(k, res[k]);
              });
            });
          }
        })
        .finally(() => {
          this.setState({ isLoading: false });
        });
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(`Error While Fetching Default Values ${error}`);
      Internal_Server_Error()
    }
  };

  /**
   * Used to switch between steps
   * @param {*} currentStep current step index
   */
  NextPrevSteps = async (currentStep) => {
    try {
      switch (currentStep) {
        case title.Next:
          //VALIDATE REGISTRATION FORM BEFORE MOVE TO CODE REQ FORM

          let isValid = await this.formRef.current
            .validateFields(REG_VALIDATE_FIELDS)
            .catch(this.onFinishFailed);

          if (isValid) {
            isValid = await this.formRef.current
              .validateFields([title.fme])
              .catch(this.onFinishFailed);
          }

          currentStep = isValid ? this.state.currentStep + 1 : 0;
          break;

        case title.Previous:
          currentStep = this.state.currentStep - 1;
          break;

        case title.Finish:
          //IN FINISH SET currentStep TO INDEX OF LAST STEP
          currentStep = 1;

          this.formRef.current.submit();
          break;
      }
      this.setState({ currentStep });
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
      Internal_Server_Error();
    }
  };

  // TO VALIDATE DUPLICATE EMPLOYEE CODE IN CASE OF AN13
  validate_employee_code = (decorator, query) => {
    if (query.length >= 8) {
      try {
        this.DataProvider.validate_emp_code_api(query).then((res) => {
          if (res.ok) {
            return res.json().then((res) =>
              this.setState(
                {
                  is_duplicate_emp_code: res.is_duplicate_emp_code,
                },
                () => {
                  this.formRef.current.setFields([
                    {
                      name: VALIDATE_FIELDS.external_number_range,
                      errors: res.is_duplicate_emp_code
                        ? [NOTIFICATION.DUPLICATE_EMP_CODE]
                        : [],
                    },
                  ]);
                }
              )
            );
          } else {
            return res.json().then((res) => {
              Object.keys(res).map((k) => {
                let title = k.replace("_", " ").replace("_", " ");
                title = title.charAt(0).toUpperCase() + title.slice(1);

                openNotification(openNotificationType.error, title, res[k]);
              });
            });
          }
        });
      } catch (error) {
        ErrorLogger(error.toString());
        console.error(decorator, error);
        Internal_Server_Error();
      }
    }
  };

  // Used to set state values from child
  setStateFromChild = (dict) => {
    try {
      Object.keys(dict).forEach((decorator) => {
        this.setState({ [decorator]: dict[decorator] });
      });
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
    }
  };

  get_dropdown_dependent_default_value = (
    app,
    model,
    dependent,
    id,
    state,
    source
  ) => {
    try {
      this.RegistrationDataProvider
        .get_dependent_dropdown_default_value_api(
          app,
          model,
          dependent,
          id,
          source
        )
        .then((res) => {
          if (res.ok) {
            return res.json().then((res) =>
              this.setState({ [state]: res.data }, () => {
                // TO SET DEFAULT VALUE IF set_default FLAG IS True
                if (res.set_default && res.data.length === 1) {
                  this.formRef.current.setFieldsValue({
                    [res.decorator]: res.data[0][res.id],
                  });
                }
              })
            );
          } else {
            openNotification(
              openNotificationType.error,
              NOTIFICATIONS.ERROR_OCCURED,
              NOTIFICATIONS.REFRESH_PAGE
            );
          }
        });
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
    }
  };

  handleChange = (decorator, value) => {
    try {
      if (decorator === DROPDOWN_FIELDS.sales_office) {
        this.formRef.current.resetFields([DROPDOWN_FIELDS.sales_group]);
        this.get_dropdown_dependent_default_value(
          DEPENDENT_DROPDOWN_FIELDS.sales_group.app,
          DEPENDENT_DROPDOWN_FIELDS.sales_group.model,
          DEPENDENT_DROPDOWN_FIELDS.sales_group.dependent,
          value.sales_office_id,
          DEPENDENT_DROPDOWN_FIELDS.sales_group.storein,
          this.state.source
        );
      }
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(`Exception ${decorator} with value ${value}`);
      console.error(error);
      Internal_Server_Error();
    }
  };

  render() {
    const { currentStep, message, isLoading, salesGroupData } = this.state;
    return (
      <>
        <StepsHeader
          formRef={this.formRef}
          currentStep={currentStep}
          NextPrevSteps={this.NextPrevSteps}
          resetFields={this.onResetFields}
        />

        {/* Loading Indicator */}
        {isLoading && <CustomLoader message={message} />}

        <div className="form_header">
          <Steps current={currentStep} onChange={this.NextPrevSteps}>
            <Step title={title.Registration} />
            <Step title={title.Code_Creation} />
          </Steps>
        </div>

        <Form
          ref={this.formRef}
          className={`ant-form ant-form-vertical`}
          onFinish={this.onFinish}
          onFinishFailed={this.onFinishFailed}
          autoComplete="off"
        >
          <div hidden={currentStep === 0 ? false : true}>
            <RegistrationFormView
              {...this.props}
              formRef={this.formRef}
              is_AN13={true}
              getChildState={this.setStateFromChild}
            />
          </div>

          <div hidden={currentStep === 1 ? false : true}>
            <CustomerCodeRequest
              formRef={this.formRef}
              disabled={false}
              validate_employee_code={this.validate_employee_code}
              salesGroupData={salesGroupData}
              handleChange={this.handleChange}
            />
          </div>
        </Form>
      </>
    );
  }
}

export default AN13FormView;
